import React from "react";
import Card from "../../../components/_payments/Card/Card";
import styles from "./Cards.module.scss";

const Cards = () => {
  return (
    <div className={styles.container}>
      <Card />
    </div>
  );
};

export default Cards;
